import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Input } from '@angular/core';
import { take } from 'rxjs/operators';
import { FileDisplayerConfig } from './file-displayer-config.interface';
import { FileReference } from './file-reference.interface';
import { MatDialog, MatDialogRef } from '@angular/material';
import { InfoPopup } from '../info-popup/info-popup';

@Component({
  selector: 'sellions-layout-renderer-file-displayer',
  templateUrl: './file-displayer.component.html',
  })
export class FileDisplayerComponent {
  @Input() baseUrl: string;
  @Input() displayName: string;
  @Input() fileDisplayerConfig: FileDisplayerConfig;
  @Input() fileReference: FileReference;

  private isImageLoaded = false;

  constructor(private http: HttpClient, private dialog: MatDialog) {}

  public isImageFile(): boolean {
    return this.isGraphicFileContent() || this.fileDisplayerConfig.forcedFileType === 'image';
  }

  private isGraphicFileContent(): boolean {
    return (
      this.fileReference !== null &&
      (this.fileReference.contentType === 'image/jpeg' ||
        this.fileReference.contentType === 'image/gif' ||
        this.fileReference.contentType === 'image/png')
    );
  }

  public downloadFile(): void {
    const dialogRef = this.getInfoPopUp('Trwa pobieranie pliku', 'Proszę czekać');

    this.http
      .get(this.getFileUrl(), {
        observe: 'response',
        responseType: 'blob',
      })
      .pipe(take(1))
      .subscribe(
        (response) => {
          dialogRef.close();

          const fakeAnchor = document.createElement('a');
          fakeAnchor.href = URL.createObjectURL(response.body);
          fakeAnchor.download = this.getFilename(response.headers);
          fakeAnchor.click();
        },
        (error) => {
          console.error(error);
          dialogRef.close();

          this.getInfoPopUp('Wystąpił błąd', 'Podczas próby pobrania pliku wystąpił błąd');
        },
      );
  }

  private getInfoPopUp(errorHeader: string, errorMessage: string): MatDialogRef<InfoPopup> {
    return this.dialog.open(InfoPopup, {
      width: '250px',
      data: { errorHeader, errorMessage },
    });
  }

  private getFilename(responseHeaders: HttpHeaders): string {
    const disposition = responseHeaders.get('Content-Disposition');
    if (disposition && disposition.indexOf('attachment') !== -1) {
      let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const matches = filenameRegex.exec(disposition);
      if (matches != null && matches[1]) {
        return decodeURIComponent(matches[1].replace(/['"]/g, ''));
      }
    }

    return '';
  }

  public getFileUrl(): string {
    // temporary solution - should be changed after adjustments in engine
    return `${this.baseUrl}${this.fileDisplayerConfig.apiPath}${this.fileReference.fileId}`;
  }

  public isSpinnerShowed(): boolean {
    return this.isImageFile() && !this.isImageLoaded;
  }

  public setImageLoaded(): void {
    this.isImageLoaded = true;
  }
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/components/file-displayer/file-displayer.component.ts